export const menuItems: MenuItem[] = [
  {
    key: "friedEggs",
    price: 9.99,
    type: "breakfast",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023045/food-app/menu/achymnprhikii7rklprf.png",
  },
  {
    key: "hawaiianPizza",
    price: 15.99,
    type: "lunchOrDinner",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023065/food-app/menu/f0vzmzkzr5ylrvecm7br.png",
  },
  {
    key: "martinezCocktail",
    price: 7.25,
    type: "drinks",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023095/food-app/menu/blzuojfa3zzrgftgki4e.png",
  },
  {
    key: "butterscotchCake",
    price: 20.99,
    type: "dessert",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023072/food-app/menu/l9mzxds6kak4bfthx2ex.png",
  },
  {
    key: "mintLemonade",
    price: 5.99,
    type: "drinks",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023076/food-app/menu/v2qjkylvz7lsrq2qhqdu.png",
  },
  {
    key: "chocolateIcecream",
    price: 18.05,
    type: "dessert",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734024897/food-app/menu/gk6czcts4q20yaljkl0n.png",
  },
  {
    key: "cheeseBurger",
    price: 12.55,
    type: "lunchOrDinner",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023085/food-app/menu/jw3cmvjaxqjhtri48zdk.png",
  },
  {
    key: "classicWaffles",
    price: 12.99,
    type: "breakfast",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023068/food-app/menu/dkvedguobwz0wwcelztv.png",
  },
  {
    key: "slicedTomatoesAndAvocados",
    price: 6.99,
    type: "starters",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023045/food-app/menu/hn96bgiuchf4dh5su7fl.jpg",
  },
  {
    key: "chocolateCake",
    price: 30.99,
    type: "dessert",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023048/food-app/menu/siyal8dq2jvtejotrvyn.jpg",
  },
  {
    key: "grilledFish",
    price: 41.56,
    type: "lunchOrDinner",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023048/food-app/menu/e40rhnva528uc9xfqc1u.jpg",
  },
  {
    key: "chickenRoast",
    price: 32.99,
    type: "lunchOrDinner",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023052/food-app/menu/c7wi0wsk05bii8afmpro.jpg",
  },
  {
    key: "stirFryNoodles",
    price: 26.99,
    type: "lunchOrDinner",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023052/food-app/menu/bo6jbe3vuabmmvqva8aa.jpg",
  },
  {
    key: "brownSoup",
    price: 12.99,
    type: "lunchOrDinner",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023056/food-app/menu/tyekyci8z2qclrgjyq7n.jpg",
  },
  {
    key: "dessert",
    price: 39.99,
    type: "dessert",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023056/food-app/menu/exbvufaibzp2dxtmupmd.jpg",
  },
  {
    key: "pastryAndBoiledEggs",
    price: 59.1,
    type: "breakfast",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023057/food-app/menu/glctuswufu73x9kdlqmx.jpg",
  },
  {
    key: "breadCornGrapes",
    price: 36.89,
    type: "breakfast",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023058/food-app/menu/thsc0k9dvctjxoazoafb.jpg",
  },
  {
    key: "drizzledSyrupOnACreamyDessert",
    price: 18.99,
    type: "dessert",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023062/food-app/menu/s4mkasckb0mwgt31d34i.jpg",
  },
  {
    key: "riceWithZucchini",
    price: 17.99,
    type: "lunchOrDinner",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023063/food-app/menu/yedmkniwswwwrcm7zepc.jpg",
  },
  {
    key: "coffeeAndCroissant",
    price: 8.99,
    type: "breakfast",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023066/food-app/menu/r0ifegin80khmogperqo.jpg",
  },
  {
    key: "grilledRibs",
    price: 89.99,
    type: "lunchOrDinner",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023071/food-app/menu/q9xfmtly6cfwuavmouu7.jpg",
  },
  {
    key: "berryCreamDessert",
    price: 14.99,
    type: "dessert",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023073/food-app/menu/qhyb1rtixjyp8tetc1ll.jpg",
  },
  {
    key: "taco",
    price: 6.99,
    type: "lunchOrDinner",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023074/food-app/menu/hcrmmbl9qjfhtfdp3ug0.jpg",
  },
  {
    key: "brownie",
    price: 10.99,
    type: "dessert",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023094/food-app/menu/ajvwyt0k7gssunfkyc78.jpg",
  },
  {
    key: "darkChocolateBrownie",
    price: 13.99,
    type: "dessert",
    image:
      "https://res.cloudinary.com/dowc89eyy/image/upload/v1734023104/food-app/menu/bicjvwl7eqmdbmivynp0.jpg",
  },
];
